<template>
  <div class="place-detail-area">
    <div class="cap1-area d-flex pd-15">
      <div
        class="heart-area active c-pointer"
        v-if="isMyStore(selectedPlace['location-id'])"
      >
        <i aria-hidden="true" class="fa fa-heart"></i>
        <p>My</p>
        <p>Store</p>
      </div>
      <div
        class="heart-area c-pointer"
        v-else
        @click.stop="setStore(selectedPlace['location-id'])"
      >
        <i aria-hidden="true" class="fa fa-heart-o"></i>
        <p>Set as</p>
        <p>My Store</p>
      </div>
      <div class="property flex-1">
        <div class="lbl-1">
          {{ selectedPlace.address.city }},
          {{ selectedPlace.address.region }}
          <span class="lbl-1-sub store-desktop"
            >(Store #{{ sprintf(selectedPlace["location-id"]) }})</span
          >
        </div>
        <div class="lbl-1-sub store-mobile md-b10">
          (Store #{{ sprintf(selectedPlace["location-id"]) }})
        </div>
        <div class="lbl-info md-b10 store-desktop store-address-details">
          {{ selectedPlace.address.street }}, {{ selectedPlace.address.city }},
          {{ selectedPlace.address.region }}
          {{ selectedPlace.address.postalCode }}
        </div>
        <div class="d-flex flex-column lbl-info md-b10 store-mobile store-address-details">
          <span>{{ selectedPlace.address.street }}, </span>
          <span
            >{{ selectedPlace.address.city }},
            {{ selectedPlace.address.region }}
            {{ selectedPlace.address.postalCode }}</span
          >
        </div>
        <div class="p-distance lbl-info store-desktop">
          <a :href="'tel:'+selectedPlace.mainPhone" class="phone-click-link"><span class="c-blue c-pointer">{{ selectedPlace.mainPhone }}</span></a>
          |
          {{ selectedPlace.distance.distanceMiles.toFixed(1) }}
          Miles |
          <a :href="selectedPlace.directionsURL" target="_blank"><span
            class="c-blue c-pointer"
            >Get Directions</span
          ></a>
        </div>
        <div class="p-distance d-flex flex-column lbl-info store-mobile">
          <a :href="'tel:'+selectedPlace.mainPhone" class="phone-click-link"><span class="c-blue c-pointer md-b10">{{
            selectedPlace.mainPhone
            }}</span></a>
          <div class="md-b10">
            {{ selectedPlace.distance.distanceMiles.toFixed(1) }}
            Miles |
            <a :href="selectedPlace.directionsURL" target="_blank"><span
              class="c-blue c-pointer"
              >Get Directions</span
            ></a>
          </div>
          <div class="switch-map md-b10 store-mobile">
            <span>Map</span>
            <b-form-checkbox
              v-model="map_checked"
              name="check-button"
              switch
            ></b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
    <div v-if="map_checked" class="store-mobile">
      <gmap-map
        :center="center"
        :zoom="13"
        style="width: 100%; height: 400px; margin-bottom: 15px"
      >
        <gmap-marker
          :position="center"
        ></gmap-marker>
      </gmap-map>
    </div>
    <div class="place-property">
      <div class="w170 bk-grey">
        <div class="c-green lbl-info t-bold md-b10">
          Open Until {{ selectedPlace.currentHours }}
        </div>
        <div
          v-html="showHours(selectedPlace.hours)"
          class="day-available"
        ></div>
      </div>
      <div class="store-amenity flex-1 bk-grey">
        <div class="lbl-info t-bold md-b10">Store Amenities & Specialties:</div>
        <div class="place-service">
          <div class="service-row">
            <img src="../../assets/img/icon_anchor.png" alt="" />
            <span class="lbl-info">Marine Services</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_wrench.png" alt="" />
            <span class="lbl-info">Auto Repair Services</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_truck.png" alt="" />
            <span class="lbl-info">Oversized Vehicles</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_handcap.png" alt="" />
            <span class="lbl-info">Accessible</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_wifi.png" alt="" />
            <span class="lbl-info">Free Wifi</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_coffee.png" alt="" />
            <span class="lbl-info">Free Coffee & Snacks</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_moon.png" alt="" />
            <span class="lbl-info">Overnight Drop-Off</span>
          </div>
          <div class="service-row">
            <img src="../../assets/img/icon_pet.png" alt="" />
            <span class="lbl-info">Pet Friendly</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-actions">
      <div class="btn-custom mw-200 disable" @click.stop="gotoBack('place')">
        <i aria-hidden="true" class="fa fa-angle-left"></i>
        <span>Back to Store Search</span>
      </div>
      <div
        @click.stop="gotoLink(selectedPlace.websiteUrl)"
        class="btn-custom mw-200 bk-blue store-details-btn"
      >
        <span class="store-detail-link">Store Details & Offers</span>
        <i aria-hidden="true" class="fa fa-angle-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    "selectedPlace",
    "isMyStore",
    "setStore",
    "sprintf",
    "showHours",
    "gotoLink",
    "gotoBack",
  ],
  data: function () {
    return {
      map_checked: false,
    };
  },
  computed: {
    center(){
      if(typeof(this.selectedPlace) == "undefined"){
        return null;
      }
      return {
        lat: this.selectedPlace.address.coordinates.latitude,
        lng: this.selectedPlace.address.coordinates.longitude
      }
    }
  }
};
</script>
<style scoped>
@media(max-width:850px){
  .store-container .location-area .place-detail-area .btn-actions {
    justify-content: space-around !important;
  }
}
.s-mobile-store .place-detail-area .store-address-details, .s-mobile-store .place-detail-area .store-address-details span {
  text-transform:uppercase !important;
}
</style>